import create from 'zustand';
import { csvParse } from 'd3-dsv';
import config from '~/../config.json';

function parseRow(row) {
  return Object.keys(row).reduce((res, key) => {
    res[key] = Number.parseFloat(`${row[key]}`.replace(',', '.'));
    return res;
  }, {});
}

const useStore = create((set, get) => ({
  age: config.defaultAge,
  currentView: config.views[0],

  dynamicXAxis: false,

  leftLoading: true,
  leftSheet: config.sheets[0],
  leftData: null,
  leftColumnsId: 'taxColumns',
  leftColumnsLabel: config.taxColumnsLabel,
  leftColumns: config.taxColumns.map((col) => ({ ...col, isActive: true })),

  rightLoading: true,
  rightSheet: config.sheets[0],
  rightData: null,
  rightColumnsId: 'paymentColumns',
  rightColumnsLabel: config.paymentColumnsLabel,
  rightColumns: config.paymentColumns.map((col) => ({ ...col, isActive: true })),

  tooltipPosition: [0, 0],
  tooltipVisible: true,
  tooltipData: null,

  setAge: (age) => set({ age: Math.max(0, Math.min(+age, 85)) }),
  setCurrentView: (currentView) => set({ currentView }),

  setCurrentSheet: (sheet, side) => {
    set({ [`${side}Sheet`]: sheet });
  },

  setColumns: (id, side) => {
    const idProp = `${side}ColumnsId`;
    const labelProp = `${side}ColumnsLabel`;
    const columnsProp = `${side}Columns`;

    const nextState = {
      [idProp]: id,
      [labelProp]: config[`${id}Label`],
      [columnsProp]: config[id].map((col) => ({ ...col, isActive: true })),
    };

    set(nextState);
  },

  toggleColumns: (side) => {
    const state = get();
    const propName = `${side}Columns`;
    const columns = state[propName];

    const oneColumnActive = columns.some((col) => col.isActive);
    const nextColumns = columns.map((col) => ({ ...col, isActive: !oneColumnActive }));

    set({ [propName]: nextColumns });
  },

  toggleColumn: (column, side) => {
    const state = get();
    const propName = `${side}Columns`;
    const columns = state[propName];

    const nextColumns = columns.map((col) => ({
      ...col,
      isActive: column === col.name ? !col.isActive : col.isActive,
    }));

    set({ [propName]: nextColumns });
  },

  loadData: async (sheet, view, side) => {
    const loadingProp = `${side}Loading`;
    const dataProp = `${side}Data`;
    set({ [loadingProp]: true });
    const csvUrl = `public/data/${sheet.id}${view.id}.csv`;

    try {
      const response = await fetch(csvUrl);
      const csv = await response.text();
      const data = csvParse(csv, parseRow);
      set({ [dataProp]: data });
      setTimeout(() => set({ [loadingProp]: false }), 100);
    } catch (err) {
      console.log(err);
    }
  },
  setLoading: (isLoading, side) => {
    const loadingProp = `${side}Loading`;
    set({ [loadingProp]: isLoading });
  },
  infoboxContent: null,
  setInfoboxContent: (infoboxContent) => {
    set({ infoboxContent });
  },
  setTooltipVisible: (tooltipVisible) => {
    set({ tooltipVisible });
  },
  setTooltipPosition: (tooltipPosition) => {
    set({ tooltipPosition });
  },
  setTooltipData: (tooltipData) => {
    set({ tooltipData });
  },
  setDynamicXAxis: (dynamicXAxis) => set({ dynamicXAxis }),
}));

export default useStore;
